export const DEFAULT_SIZE_CONVERTER = (value: number | string) => {
    const strValue = `${value}`;

    // naively assume only px and pt would be used
    if (/p[tx]$/.test(strValue)) {
        return strValue;
    }

    // default to pixels for the view otherwise
    return `${strValue}px`;
};
